import { render, staticRenderFns } from "./plans_billing.vue?vue&type=template&id=a221c788&scoped=true&"
import script from "./plans_billing.vue?vue&type=script&lang=js&"
export * from "./plans_billing.vue?vue&type=script&lang=js&"
import style0 from "./plans_billing.vue?vue&type=style&index=0&id=a221c788&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a221c788",
  null
  
)

export default component.exports